<template>
  <div v-if="status" dir="rtl" class="modal__error slide-top"
       style="z-index: 999999999999999; top: 47%; width: 80vw; height: 40vw;">
    <div>
      <p>نهاده - {{ title }}</p>
      <p @click.prevent="$emit('close')">❌</p>
    </div>
    <div>
      <div class="d-flex flex-column overflow-scroll w-100" style="height: 32vw;">
<!--              <InputsInformationsItem :insert="show_insert" :id="id" name="سرمایه" type="2" label_one="عنوان" label_two="مقدار (واحد)" />-->
        <div class="measurement-box">
          <h3>نیروی انسانی</h3>
          <hr class="mx-3">
          <Manpower :sub-process-id="id"/>
        </div>
        <div class="measurement-box">
          <h3>سرمایه</h3>
          <hr class="mx-3">
          <EffectsMeasurement :sub-process-id="id" type="سرمایه نهاده"/>
        </div>
        <div class="measurement-box">
          <h3>فناوری</h3>
          <hr class="mx-3">
          <EffectsMeasurement :sub-process-id="id" type="فناوری نهاده"/>
        </div>
        <div class="measurement-box">
          <h3>خدمت/کالای واسطه</h3>
          <hr class="mx-3">
          <EffectsMeasurement :sub-process-id="id" type="کالای واسطه نهاده"/>
        </div>
      </div>

      <!-- محتوای دیگر -->
      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3 pt-2"
           style="width: 25%; position:fixed; bottom: 0; border-top: 1px solid #999;">
        <button @click.prevent="$emit('close')" class="btn btn-primary btn-back" type="submit">برگشت</button>
      </div>
    </div>
  </div>
</template>

<script>
import InputsInformationsItem from "@/components/Impact_Assessment/Input/InputsInformationsItem.vue";
import EffectsMeasurement from "@/components/PerformanceManagement/EffectsMeasurement";
import Manpower from "@/components/PerformanceManagement/EffectsMeasurement/Manpower.vue";

export default {
  components: {Manpower, InputsInformationsItem, EffectsMeasurement},
  props: {
    show_insert: Boolean,
    status: Boolean,
    title: String,
    id: Number
  }
};
</script>

<style scoped>
.measurement-box {
  border: .1vw solid #999;
  border-radius: .4vw;
  margin: 1.5vw 6vw;
  padding: .3vw 3vw;
  background: white;
}

.measurement-box h3 {
  font-size: 1.2vw !important;
  margin: 1vw auto;
}
</style>
